// Chart loader utility for lazy loading charts
let chartsLoaded = false;

export async function loadCharts() {
    if (chartsLoaded) {
        return window.c3;
    }

    try {
        // Dynamic import of charts module
        const chartsModule = await import('./charts.js');
        chartsLoaded = true;
        return chartsModule.default;
    } catch (error) {
        console.error('Failed to load charts:', error);
        throw error;
    }
}

// Global function for Blade templates
window.loadCharts = loadCharts;

export default loadCharts;